import React, { useState, useEffect, useContext } from "react"

import { navigate } from "gatsby"
import { Row, Col, Container } from "react-bootstrap"

import { GlobalAuthContext } from "../../context/authContext"

import Check from "../../images/check.png"

import Spinner from "../spinner/spinner"
import { VERIFY_PAY } from "./payment-actions"
import SEO from "../seo"
import BreadcrumbComponent from "../breadcrumb/breadcrum"

const PaySuccess = ({ page }) => {
  const [wholePageLoading, setWholePageLoading] = useState(true)

  const { state } = useContext(GlobalAuthContext)

  const pages = [{ name: "Home", link: "/" }]
  const currentPage = { link: "/company/checkout/", name: "Checkout" }

  useEffect(() => {
    if (state.isAuthenticated && page.oid && page.refId) {
      VERIFY_PAY(page, setWholePageLoading)
    } else {
      navigate("/company/checkout?type=esewa&q=failed")
    }
  }, [state.isAuthenticated]) // eslint-disable-line react-hooks/exhaustive-deps
  if (wholePageLoading) {
    return <Spinner />
  } else {
    return (
      <>
        <BreadcrumbComponent currentPage={currentPage} pages={pages} />
        <Container className="mt-5 pt-5 mb-5 pb-5 text-center">
          <SEO title="Payment Successful | WDN" />
          <Row>
            <Col lg="6" className="offset-lg-3">
              <h1 className="thank-you mb-2">Thank You!</h1>
              <div className="d-flex align-items-center justify-content-center mb-4">
                <div className="icon-payment-done-success">
                  <img src={Check} alt="wdn-tick" />
                </div>
                <div className="payment-done-success">
                  <h3>Payment Done Successfully</h3>
                </div>
              </div>
              <p>
                Thank You for taking services from WDN - Worker’s Directory
                Nexus. Please check your email for Invoice.
              </p>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}

export default PaySuccess
